import { render, staticRenderFns } from "./FallRadarKanBan.vue?vue&type=template&id=1d8cc5b4&scoped=true"
import script from "./FallRadarKanBan.vue?vue&type=script&lang=js"
export * from "./FallRadarKanBan.vue?vue&type=script&lang=js"
import style0 from "./FallRadarKanBan.vue?vue&type=style&index=0&id=1d8cc5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8cc5b4",
  null
  
)

export default component.exports